import { generateTestId } from "@client-shared";

export const setDialogHeaderContentTestId = (identifier: string): string => generateTestId("DialogHeaderContent", identifier);

export const setDialogHeaderContentIconTestId = (identifier: string): string => generateTestId("DialogHeaderContentIcon", identifier);

export const setDialogHeaderContentTitleTestId = (identifier: string): string => generateTestId("DialogHeaderContentTitle", identifier);

export const setDialogHeaderContentDescriptionTestId = (identifier: string): string =>
  generateTestId("DialogHeaderContentDescription", identifier);
